<!-- app-roll-up move to here as this function only available in report view for now  -->
<div class="toolbar-container">
  <app-report-export-png></app-report-export-png>
  <app-roll-up></app-roll-up>
</div>
